import React from "react";
import { Form } from "react-bootstrap";

const InputText = React.forwardRef(({ id, value, onValueChange, onChange, ...rest }, ref) => {

    function handleChange(e) {
        if(onChange) onChange(e);
        if(onValueChange) onValueChange(e.target.value);
    }

    return (
        <Form.Control id={id}
            value={value}
            onChange={handleChange}
            ref={ref}
            {...rest}
        />
    )

});

export default InputText;